<template>
  <RfAlert :type="variant">
    <div class="flex items-center gap-2">
      <span>{{ displayMessage }}</span>
      <RfButtonNew v-if="showRetry" type="table" @click="$emit('retry')">Retry</RfButtonNew>
      <RfProgressActivityIcon v-else class="h-4! w-4! shrink-0 animate-spin" />
    </div>
  </RfAlert>
</template>

<script setup>
import { computed } from "vue";
import RfAlert from "@/components/alerts/RfAlert.vue";
import RfButtonNew from "@/components/buttons/RfButtonNew.vue";
import RfProgressActivityIcon from "@/components/icons/RfProgressActivityIcon.vue";

const props = defineProps({
  variant: {
    type: String,
    default: "info",
  },
  message: {
    type: String,
    default: "",
  },
  showRetry: {
    type: Boolean,
    default: false,
  },
});
defineEmits(["retry"]);

const displayMessage = computed(
  () =>
    props.message ||
    (props.variant === "error"
      ? "We couldn't prepare your metrics. Please try again."
      : "We're fetching your data, please give us a moment"),
);
</script>
